'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["arg", "searchParams", "hashAlg", "mtime", "mode"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var modeToString = require('./mode-to-string.js');

var parseMtime = require('./parse-mtime.js');

function toUrlSearchParams() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      arg = _ref.arg,
      searchParams = _ref.searchParams,
      hashAlg = _ref.hashAlg,
      mtime = _ref.mtime,
      mode = _ref.mode,
      options = _objectWithoutProperties(_ref, _excluded);

  if (searchParams) {
    options = _objectSpread(_objectSpread({}, options), searchParams);
  }

  if (hashAlg) {
    options.hash = hashAlg;
  }

  if (mtime != null) {
    mtime = parseMtime.parseMtime(mtime);
    options.mtime = mtime.secs;
    options.mtimeNsecs = mtime.nsecs;
  }

  if (mode != null) {
    options.mode = modeToString.modeToString(mode);
  }

  if (options.timeout && !isNaN(options.timeout)) {
    options.timeout = "".concat(options.timeout, "ms");
  }

  if (arg === undefined || arg === null) {
    arg = [];
  } else if (!Array.isArray(arg)) {
    arg = [arg];
  }

  var urlSearchParams = new URLSearchParams(options);
  arg.forEach(function (arg) {
    return urlSearchParams.append('arg', arg);
  });
  return urlSearchParams;
}

exports.toUrlSearchParams = toUrlSearchParams;